import script from "./LanguagesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguagesForm.vue?vue&type=script&setup=true&lang=js"

import "./LanguagesForm.vue?vue&type=style&index=0&id=f8df56ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8df56ce"]])

export default __exports__